export const socialLinks = [
  {
    icon: "LinkedInIcon",
    href: "https://www.linkedin.com/in/omkar-khoche-964a86259/",
    label: "LinkedIn",
  },
  {
    icon: "TwitterIcon",
    href: "https://twitter.com/omkarkhoche",
    label: "Twitter",
  },
  {
    icon: "GithubIcon",
    href: "https://github.com/OmkarKhoche3448",
    label: "GitHub",
  },
  {
    icon: "InstagramIcon",
    href: "https://www.instagram.com/omkar_khoche",
    label: "Instagram",
  },
];

export const startupsContent = [
  {
    name: "WYSWYG Solution",
    role: "Frontend Developer",
    period: "Feb 2024 – May 2024",
  },
  {
    name: "Elivatics",
    role: "Full Stack Developer",
    period: "Dec 2024 – Present",
  },
];
